import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { XmlUploader } from '../custom';

export interface ProductResource
    extends ng.resource.IResourceClass<ng.resource.IResource<any>>,
        XmlUploader {
    getPossibleSlotsForBundleMatrices: ng.resource.IResourceMethod<
        ng.resource.IResource<number[]>
    >;
    getCompetitions: ng.resource.IResourceMethod<
        ng.resource.IResource<ProductCompetitionOverviewDto>
    >;
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<ManualProductUploadDto>
    >;
}

function productResource(
    $resource: ng.resource.IResourceService
): ProductResource {
    return <ProductResource>$resource(
        config.monolithApi + '/product-upload',
        {},
        {
            getPossibleSlotsForBundleMatrices: {
                method: 'GET',
                url: config.monolithApi + '/product-upload/possible-slots',
                isArray: true
            },
            getCompetitions: {
                method: 'GET',
                url: config.monolithApi + '/product-upload/competition/:txId',
                isArray: true
            },
            generateXml: {
                method: 'POST',
                url: config.monolithApi + '/product-upload/as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/product-upload',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        }
    );
}

angular.module('app').factory('productResource', productResource);
